export default __webpack_public_path__ + "static/media/mesmol.7388bb4a.jpg";